<!-- @format -->

@if (isAnyServiceBreakInfoToShow) {
  <div class="service-breaks">
    @for (serviceBreak of currentServiceBreaks; track serviceBreak) {
      <article
        class="service-break"
        [attr.aria-label]="getServiceInfoText(serviceBreak)"
        [ngClass]="hasServiceBreakPassed(serviceBreak) ? 'service-break--passed' : 'service-break--not-passed'">
        @if (!hasServiceBreakPassed(serviceBreak)) {
          <fudis-icon [icon]="'exclamation-mark-circle-fill'" class="service-break__exclamation-mark-icon" aria-hidden="true" />
        }
        @if (!hasServiceBreakPassed(serviceBreak)) {
          <span class="visually-hidden">{{ "ARIA_LABEL.NOTIFICATION_WARNING" | translate }}</span>
        }
        <span class="service-break__info-text">{{ getServiceInfoText(serviceBreak) }}</span>
        <div class="service-break__secondary">
          @if (isAdditionalInfo(serviceBreak)) {
            <div class="service-break__secondary__additional-info">
              <button type="button" class="link-button ng-scope" (click)="openInfoDialog(serviceBreak)">
                <fudis-icon [icon]="'info-circle'" [color]="'primary'" />
                <span translate>UNAVAILABLE.ADDITIONAL_INFO</span>
              </button>
            </div>
          }
          @if (isReleaseNotes(serviceBreak)) {
            <div class="service-break__secondary__release-notes">
              <a
                fudisLink
                [href]="serviceBreak.releaseNotesLink | localizedString"
                [external]="true"
                [title]="'UNAVAILABLE.EXTERNAL_LINK' | translate"></a>
            </div>
          }
        </div>
      </article>
    }
  </div>
}
